import { Ontotis } from "./types";

export const DefaultOntotis: Ontotis = {
    title: '',
    parent_id: null,
    description: '',
    subontotisname: '',
    address: '',
    city: '',
    postalCode: '',
    phone1: '',
    phone2: '',
    email: '',
    unit_id: null,
    customorder: 0,
}
